import { Review, ApiResult } from '../../../types';
import { REVIEWS_KEY } from './constants';
import { ReviewMapper } from '../mappers/review.mapper';

export class LocalReviewsRepo {
    async getReviewsForListing(listingId: string): Promise<Review[]> {
        const all = this.loadReviews();
        return all
            .map(r => ReviewMapper.toDomain(r))
            .filter(r => r.listingId === listingId);
    }

    async getMyReviewForListing(userId: string, listingId: string): Promise<Review | null> {
        const all = this.loadReviews();
        return all
            .map(r => ReviewMapper.toDomain(r))
            .find(r => r.listingId === listingId && r.userId === userId) || null;
    }

    async createReview(params: Omit<Review, 'id' | 'createdAt'>): Promise<ApiResult<Review>> {
        const all = this.loadReviews();
        const reviewId = crypto.randomUUID();
        const createdAt = new Date().toISOString();
        const row = ReviewMapper.toRow({ ...params, id: reviewId, createdAt });

        all.push(row);
        this.saveReviews(all);
        return { success: true, data: ReviewMapper.toDomain(row) };
    }

    private loadReviews(): any[] {
        try {
            const s = localStorage.getItem(REVIEWS_KEY);
            return s ? JSON.parse(s) : [];
        } catch { return []; }
    }

    private saveReviews(r: any[]) {
        localStorage.setItem(REVIEWS_KEY, JSON.stringify(r));
    }
}
